import { Button, Form, Input, InputNumber, Modal, Popconfirm, Row, Space } from 'antd'
import { ProductionRate } from '../../domain/productionRate'
import Units from '../Items/Units'
import { useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo } from '@fortawesome/pro-solid-svg-icons'
import { faRight } from '@fortawesome/pro-duotone-svg-icons'
import IconAndTextButton from '../IconAndTextButton'

export type Props = {
  isOpen: boolean
  productionRate?: Partial<ProductionRate>
  onChange: (productionRate: ProductionRate) => void
  onCancel: () => void
  onClear: () => void
}

const ProductionRateForm = ({ isOpen, productionRate, onChange, onCancel, onClear }: Props) => {
  const [form] = Form.useForm()
  const ref = useRef<any>()
  const handleSubmit = async () => {
    const values = await form.validateFields()
    onChange(values)
    setTimeout(() => form.resetFields(), 100)
  }

  const handleCancel = () => {
    onCancel()
    setTimeout(() => form.resetFields(), 100)
  }

  useEffect(() => {
    form.setFieldsValue(productionRate)
    setTimeout(() => ref.current?.select(), 1)
  }, [productionRate, isOpen, form])

  return <Modal
    open={isOpen}
    title="Production Rate"
    onCancel={handleCancel}
    footer={
      <Row justify="space-between">
        <Popconfirm title="Are you sure you want to clear the production rate for this item?" onConfirm={onClear}>
          <IconAndTextButton danger icon={faUndo} text="Clear Production Rate" />
        </Popconfirm>
        <Space>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" onClick={handleSubmit}>OK</Button>
        </Space>
      </Row>
    }
  >
    <Form form={form} layout="inline" onFinish={handleSubmit}>
      <Form.Item name="rateInstallationQuantity" required>
        <InputNumber style={{ width: 100 }} min={0} placeholder="Quantity" ref={ref} />
      </Form.Item>
      <Form.Item name="ratePerUnits" required>
        <Input style={{ width: 100 }} placeholder="Units" />
      </Form.Item>
      <Form.Item><FontAwesomeIcon icon={faRight} /></Form.Item>
      <Form.Item name="rateUsageQuantity" style={{ width: 140 }} required>
        <InputNumber placeholder="Quantity" addonAfter={<Units width={40} fontSize={11} units={productionRate?.units ?? ''} />} min={0} />
      </Form.Item>
    </Form>
  </Modal>
}

export default ProductionRateForm
